import axios from 'axios';

//direccion peticion API
const baseURL = '/api/FAQ';

async function getAll(language){
    const { data } = await axios.get(baseURL + "?language=" + language);
    return data;
}

export default { getAll };